import React from "react";
import {Swiper, SwiperSlide, } from "swiper/react";
import { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import '../style/homeCarousel.less';


// 轮播参数
interface CarouselProps {
	data: string[]; // 图片地址列表
	speed?: number; // // 轮播速度，默认2秒
	className?: string;
}


const HomeCarousel = (props: CarouselProps) => {
	const { speed = 2, data } = props;
	const banners = Array.isArray(data) ? data : [];
	return (
		<div className="home-carousel-wrapper">
			<Swiper
				modules={[Navigation, Pagination, Autoplay]}
				navigation={true}
				pagination={{ clickable: true }}
				autoplay={{
					delay: speed * 1000, // 间隔的时间
					disableOnInteraction: true
				}}
				// speed={speed * 1000}
				loop={true}
				allowTouchMove={false}
			>
				{
					banners.map((imgSrc) => (
						<SwiperSlide key={imgSrc}>
							<img src={imgSrc} className="w" loading="lazy" />
						</SwiperSlide>
					))
				}
			</Swiper>
		</div>
	)
}


export default HomeCarousel;
